module.exports = __webpack_public_path__ + "img/dsci0007.ffed3c75.jpg";